export const onSaveChannelMappingFromS3 = `subscription onSaveChannelMappingFromS3($cpId: String!) {
  onSaveChannelMappingFromS3(cpId: $cpId) {
    cpId
    jobId
  } 
}
`;